<template>
  <div class="radio-group">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'BaseRadioGroup',

  props: {
    value: ''
  },

  componentName: 'BaseRadioGroup',

  created () {
    this.$on('handleChange', value => {
      this.$emit('change', value)
    })
  }
}
</script>

<style lang="scss">
.radio-group {
  display: inline-block;
  & > .base-radio {
    & > .base-radio__inner {
      border-radius: 0;
    }
    &:first-child > .base-radio__inner {
      border-radius: 4px 0 0 4px;
    }
    &:last-child > .base-radio__inner {
      border-radius: 0 4px 4px 0;
    }
    &:first-child:last-child > .base-radio__inner {
      border-radius: 4px;
    }

    & + .base-radio {
      margin: 0;
    }
  }
}
</style>
